<template>
  <section
    class="slot-machine-main"
    :style="{
      backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none',
      '--slot-bgColor': activityData.property.bgColor,
      '--slot-textColor': activityData.property.textColor,
      '--slot-tryBoxColor': activityData.property.tryBoxColor,
      '--slot-winBgColor': activityData.property.winBgColor,
      '--slot-lostBgColor': activityData.property.lostBgColor,
      backgroundImage: `url(${activityData.images.bg})`,
    }">
    <Header />
    <div class="pre-game" v-show="preGame">
      <transition appear name="translateRight">
        <div class="slot-logo">
          <!-- <img src="@/assets/img/logoSlot.png" alt> -->
        </div>
      </transition>
      <transition appear name="open">
        <div class="action-column">
          <div class="jogue-concorra">
            JOGUE E
            <br />
            CONCORRA A PRÊMIOS!
          </div>
          <button class="jogar" @click.prevent="preGame = !preGame">JOGAR</button>
        </div>
      </transition>
    </div>
    <div class="won" v-show="won">
      <button class="dismiss-btn" @click.prevent="won = false">X</button>
      <iframe class="slot-iframe" id="FrameWin" :src="activityData.property.iframeWin" frameborder="0"></iframe>
    </div>
    <div class="lost" v-show="lost">
      <button class="dismiss-btn" @click.prevent="lost = false">X</button>
      <iframe class="slot-iframe" id="FrameLost" :src="activityData.property.iframeLose" frameborder="0"></iframe>
    </div>
    <div class="master-wrapper" v-show="!preGame && !won && !lost">
      <div class="game-container">
        <iframe ref="slotFrame" class="slotFrame" :src="iframeSrc" frameborder="0"></iframe>
        <div class="tries-container">
          <div class="tries">
            TENTATIVAS:
            <div class="try">{{ plays }}</div>
          </div>
        </div>
      </div>
      <div class="instructions-container">
        <div class="modo-de-jogar" v-html="activityData.property.instructions" v-if="activityData.property.instructions"></div>
        <div v-else>
          <span style="font-size: 1.9rem; color: #000000"><b>MODO DE JOGAR:</b></span>
          <div style="font-size: 1.5em; color: #000000">• Clique na alavanca para girar a Máquina de Prêmios.</div>
          <div style="font-size: 1.5rem; color: #000000">• Você ganhará o prêmio caso apareçam 3 imagens iguais.</div>
        </div>
        <br />
        <br />
        <!-- <div class="bullet-point">Combinações:</div> -->
        <div class="combines-wrapper">
          <img :src="activityData.property.combineImage1" alt="" />
          <img :src="activityData.property.combineImage2" alt="" />
          <img :src="activityData.property.combineImage3" alt="" />
        </div>
        <!-- <div class="premio">PRÊMIO: 3.000 PONTOS LIVELO</div> -->
        <!-- <div class="bullet-point">• won? Leva pontos LIVELO que chegarão em seu email.</div> -->
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';

export default {
  name: 'SlotMachine',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      preGame: false,
      won: false,
      lost: false,
      plays: 0,
      NUMBER_PLAYS: 6,
      prize: 0,
      totalPrize: 0,
      activityData: { images: {}, property: { bgColor: '#000000' }, interactivities: [] },
      iframeSrc: '',
    };
  },
  methods: {
    loadActivity() {
      api.get(`activity/${this.$route.params.stream}`).then((response) => {
        let tempImages = { ...this.activityData.images };
        this.activityData = { ...this.activityData, ...response.data };
        this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;
        this.activityData.property = JSON.parse(response.data.property);

        this.iframeSrc = this.activityData.property.src;

        this.getChances();
      });
    },

    getChances() {
      api.get(`activity/${this.$route.params.stream}/slotMachineChances`).then((response) => {
        if (response.data) {
          this.plays = response.data.chances;
        } else {
          this.plays = this.NUMBER_PLAYS;
        }
        if (this.plays < 0) this.plays = 0;

        this.iframeSrc = `${this.iframeSrc}?chances=${this.plays}&bgColor=${this.activityData.property.bgColor.replace('#', '')}`;
        // this.iframeSrc = `http://127.0.0.1:5500/index.html?chances=${this.plays}&bgColor=${this.activityData.property.bgColor.replace('#', '')}`;
      });
    },
    getResults() {
      return new Promise((resolve, reject) => {
        api
          .post(`activity/${this.$route.params.stream}/slotMachine`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            this.plays = 0;
            reject(err);
          });
      });
    },

    savePlay(resultGame) {
      this.won = resultGame.result;
      this.lost = !this.won;
      const obj = {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        game_id: this.$route.params.stream,
        session_id: this.$store.state.user.token,
        game_play: 1,
        game_result: resultGame.result ? 1 : 0,
      };
      api
        .post(`event/${this.$store.state.eventId}/gameResult/`, obj)
        .then((_) => {
          if (this.plays < 0) this.plays = 0;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async onMessage(e) {
      try {
        const data = JSON.parse(e.data);
        if (data.playGame === true) {
          const result = await this.getResults();

          this.$refs.slotFrame.contentWindow.postMessage(JSON.stringify(result), '*');
          this.plays = this.plays - 1;
          if (this.plays < 0) this.plays = 0;
        }
        if (data.finishedGame === true) {
          const resultGame = data.resultGame;
          this.savePlay(resultGame);
        }
      } catch {}
    },
  },
  mounted() {
    window.addEventListener('message', this.onMessage);
  },
  beforeMount() {
    this.loadActivity();
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  },
};
</script>

<style lang="scss">
.slot-machine-main {
  background-position: right;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  font-family: 'Montserrat', sans-serif;
  color: white;
  background-color: var(--slot-bgColor);
  color: var(--slot-textColor);
}
.pre-game {
  display: flex;
  align-items: center;
  background-color: #ff81ef;
  width: 98vw;
  height: 100dvh;
  padding-bottom: 2%;
  .slot-logo {
    padding: 1%;
    padding-left: 8%;
    img {
      width: auto;
      height: auto;
      max-width: 90%;
      max-height: 90%;
    }
  }
  .action-column {
    display: flex;
    flex-direction: column;
    padding: 2%;
    .jogue-concorra {
      font-size: 2.5vw;
      font-weight: bold;
      color: #eae321;
    }
    .jogar {
      font-size: 2.5vw;
      font-weight: bold;
      color: white;
      background: #6a2d8b;
      padding: 2% 16% 2% 16%;
      margin-top: 4%;
      border-radius: 15px;
      border: none;
      outline: none;
      cursor: pointer;
    }
    .jogar:hover {
      color: #eae321;
      background: #11468a;
    }
  }
}
.master-wrapper {
  display: flex;
  min-height: 97vh;
}
.game-container {
  position: relative;
  width: 55%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
}
.slotFrame {
  padding: 5%;
  padding-top: 15%;
  width: 100%;
  height: 76vh;
}
iframe:focus {
  outline: none;
}
iframe[seamless] {
  display: block;
}
.tries-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  .tries {
    position: relative;
    font-size: 1.1rem;
    letter-spacing: 5px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 20px;

    .try {
      position: relative;
      background-color: var(--slot-tryBoxColor);
      font-size: 5rem;
      width: 100%;
      padding: 3% 10%;
      border-radius: 20px;
    }
  }
}

.instructions-container {
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  height: 100%;
  width: 45%;
  margin-top: 110px;
  margin-left: 1%;

  .modo-de-jogar {
    font-size: 1.3rem;
    letter-spacing: 3px;
    font-weight: bold;
    margin-bottom: 1%;
    margin-right: 2%;
  }
  .bullet-point {
    font-size: 1rem;
    letter-spacing: 3px;
    font-weight: lighter;
  }
  .combines-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 1%;
    margin-left: -2%;
    margin-right: 1%;
  }
  img {
    width: auto;
    padding-top: 1%;
    padding-bottom: 1%;
    padding-right: 2%;
  }
  .premio {
    font-size: 1.3rem;
    letter-spacing: 3px;
    font-weight: bold;
    margin-top: 5%;
    margin-bottom: 1%;
  }
}
.won {
  position: relative;
  display: flex;
  align-items: flex-end;
  background-color: var(--slot-winBgColor);
  width: 100vw;
  height: 100dvh;
  .won-textos {
    position: relative;
    align-self: center;
    z-index: 1;
    margin-left: 5%;
    margin-right: 8%;
    margin-top: -14%;
    .congratulations {
      align-self: center;
      color: #eae321;
      font-size: 3.3rem;
      font-weight: bold;
      letter-spacing: 4px;
      margin-bottom: 4%;
    }
    .notice {
      align-self: center;
      color: white;
      font-size: 2rem;
      letter-spacing: 3px;
    }
  }
}
.lost {
  display: flex;
  align-items: flex-end;
  background-color: var(--slot-lostBgColor);
  width: 100vw;
  height: 100dvh;
  .lost-texts {
    position: relative;
    align-self: center;
    z-index: 1;
    margin-left: 40%;
    margin-right: 8%;
    margin-top: -14%;
    .nao-foi-dessa-vez {
      color: #eae321;
      font-size: 3.3rem;
      font-weight: bold;
      letter-spacing: 4px;
      margin-bottom: 4%;
    }
    .vc-ainda-pode {
      align-self: center;
      color: white;
      font-size: 2rem;
      letter-spacing: 3px;
    }
  }

  .travolta {
    position: absolute;
    left: 0;

    img {
      height: 80vh;
    }
  }
}
.dismiss-btn {
  position: absolute;
  right: 0;
  top: 120px;
  font-size: 3rem;
  font-weight: lighter;
  color: white;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: 1;
}
.slot-iframe {
  height: 100%;
  width: 100%;
}
@include media('<=tablet') {
  .master-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 5%;
    padding-left: 5%;
    padding-top: 59px;
    padding-bottom: 600px;
  }
  .game-container {
    width: 100%;
  }
  .slotFrame {
    padding-top: 15%;
    width: 95vw;
    height: 95vw;
  }
  .tries-container {
    margin-left: 5%;
    padding-right: 5%;
  }
  .instructions-container {
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    justify-content: center;
    height: 100%;
    width: 90%;
    margin-top: 5%;
    margin-bottom: 5%;
    margin-left: 4%;
    margin-right: 4%;
    .combines-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-top: 2%;
      margin-left: 0%;
      margin-right: 0%;
    }
    img {
      max-width: 100%;
      padding-top: 1%;
      padding-bottom: 1%;
    }
  }
  .lost {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .lost-texts {
      position: relative;
      align-self: flex-end;
      margin: 140px 8% auto 8%;
      @include media('<=phone') {
        margin: 50% 8%;
      }
      .nao-foi-dessa-vez {
        @include media('<=phone') {
          font-size: 2rem;
        }
      }
    }
  }

  .travolta {
    position: absolute;
    right: -200px;
    max-height: 600px;
    @include media('<=phone') {
      max-height: 300px;
    }
  }
  .won {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .won-textos {
      .congratulations {
        @include media('<=phone') {
          font-size: 2.3rem;
        }
      }
      .notice {
        @include media('<=phone') {
          font-size: 1rem;
        }
      }
    }
  }

  .chuck {
    position: absolute;
    bottom: 0;
    img {
      height: 300px;
    }
  }
}

.dismiss-btn {
  position: absolute;
  right: 3%;
  top: 120px;
  font-size: 3rem;
  font-weight: lighter;
  color: white;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

// ANIMATIONS
.translateRight-enter-active {
  transition: all 0.8s ease-in-out;
}
.translateRight-leave-active {
  transition: all 0.8s ease-in-out;
}

.translateRight-enter,
.translateRight-leave-to {
  transform: translateX(-100px);
}

.open-enter-active {
  animation: bounce-in-from-top 0.5s;
}
.open-leave-active {
  animation: bounce-in-from-top 0.5s reverse;
}
@keyframes bounce-in-from-top {
  0% {
    transform: scale(0);
    transform: translateX(-100px);
    transform: translateY(-10px);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
